const NotFound = () => {
  return (
    <>404 Not found</>
  )
}

export default NotFound;